/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { getCountryRoutes, MediaType } from "@nf/common";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { ReactElement } from "react";

const Layout = dynamic(() => import("layouts/Layout"));

const SeriesDetailsScreen = dynamic(
  () => import("screens/SeriesDetailsScreen/SeriesDetailsScreen")
);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const setCacheHeader = await import("helpers/cacheHeaderHelper").then(
    (mod) => mod.setCacheHeader
  );

  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);
  const countryRoutes = getCountryRoutes(commonProps.country);

  const country = commonProps.country;
  const language = commonProps.language;

  setCacheHeader(ctx.res);

  const media = await DataProvider.getMedia({
    MediaId: `${ctx.params?.id}`,
    AssetType: MediaType.Series,
    IncludeCategories: true,
    IncludeProgress: true,
    IncludeSeasons: true,
    IncludeEpisodes: true,
    IncludeSeoData: true,
    OnlyPublished: false,
  });

  if (commonProps?.isChild && media?.ContentAdvisory) {
    return {
      redirect: {
        destination: `/${country}/${language}${countryRoutes.KIDS}`,
      },
      props: {},
    };
  }

  return {
    props: {
      ...commonProps,
      media,
    },
  };
};

const SeriesDetailsScreenWrapper = (props: any) => {
  return <SeriesDetailsScreen {...props} />;
};

SeriesDetailsScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout
      config={props?.config}
      navigation={{
        visibility: { phone: false, tablet: false, desktop: true, large: true },
        logo: { show: true },
        menu: { show: true },
        search: { show: true },
        userInfo: { show: true },
      }}
    >
      {page}
    </Layout>
  );
};

export default SeriesDetailsScreenWrapper;
